import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
export function PatientProjectionEmptyStep() {
    const { t } = useLocale();
    return (_jsxs("section", { "aria-labelledby": "projection-empty-heading", children: [_jsx("h3", { id: "projection-empty-heading", children: t('projection.empty.heading') }), _jsx("p", { children: t('projection.empty.body') })] }));
}
//# sourceMappingURL=empty-step.js.map